import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {Divider, Form, Input} from 'antd';
import _ from 'lodash';

import VideoUpload from './VideoUpload';
import {videoDataPropTypes} from './propTypes';

import titleStyles from './VideoForm.less';
import VideoThumbEditor from './VideoThumbEditor';

export default function VideoForm({category, videoData, onChange}) {
    const formRef = useRef();

    function onFinish(values) {
        console.log('Received values of form: ', values);
    }

    function onValuesChange(changedValues, allValues) {
        onChange && onChange({...videoData, ...allValues});
    }

    function onUploadChange(video) {
        // console.log('onUploadChange', video, videoData);
        let title = _.get(videoData, 'title');
        if (!title) {
            title = _.get(video, 'title');
            formRef.current.setFieldsValue({title});
        }
        let thumbAttachId = _.get(videoData, 'thumbAttachId');
        if (!thumbAttachId) {
            thumbAttachId = _.get(video, 'thumbAttachId');
            let thumbAttachExt = _.get(video, 'thumbAttachExt');
            let thumbAttachSize = _.get(video, 'thumbAttachSize');

            formRef.current.setFieldsValue({thumbAttachId});
            formRef.current.setFieldsValue({thumbAttachExt});
            formRef.current.setFieldsValue({thumbAttachSize});
        }
        onChange && onChange({...videoData, ...video, title});
    }

    function onThumbChange(thumbAttachId, thumbAttachExt) {
        onChange && onChange({...videoData, thumbAttachId, thumbAttachExt});

        formRef.current.setFields([
            {
                name: 'thumbAttachId',
                value: thumbAttachId,
            },
            {
                name: 'thumbAttachExt',
                value: thumbAttachExt,
            },
        ]);
    }

    return (
        <Form
            ref={formRef}
            onFinish={onFinish}
            onValuesChange={onValuesChange}
            layout="vertical"
            initialValues={videoData}
        >
            <Form.Item hidden name="id">
                <Input />
            </Form.Item>

            <Form.Item name="title">
                <Input
                    className={titleStyles.titleInput}
                    autoFocus
                    placeholder="在此输入标题"
                    maxLength={30}
                    size="large"
                />
            </Form.Item>

            <Divider />

            <VideoUpload category={category} videoData={videoData} onChange={onUploadChange} />

            <Divider />

            <Form.Item hidden name="thumbAttachId">
                <Input />
            </Form.Item>

            <Form.Item hidden name="thumbAttachExt">
                <Input />
            </Form.Item>

            <VideoThumbEditor video={videoData} onThumbChange={onThumbChange} />

            <Divider />

            <Form.Item
                name="description"
                label="摘要"
                rules={[
                    {
                        max: 50,
                    },
                ]}
            >
                <Input.TextArea placeholder="摘要（选填）" maxLength={50} rows={2} />
            </Form.Item>
        </Form>
    );
}

VideoForm.propTypes = {
    category: PropTypes.oneOf(['media', 'message']),
    videoData: videoDataPropTypes,
    onChange: PropTypes.func,
};
